function Hero() {
  return (
    <div className="hero">
      <div className="hero-content">
        <h1>Delicious Food, Delivered</h1>
        <p>Experience the best meals in town</p>
        <button onClick={() => {
          document.getElementById("menu").scrollIntoView({ behavior: "smooth" });
        }}>
          View Menu
        </button>
      </div>
    </div>
  );
}

export default Hero;